module.exports = __webpack_public_path__ + "assets/img/route2media.cd5cbc6a.jpg";